export default __webpack_public_path__ + "static/media/image_03.1718d733.png";